import { AppConfigKey_FE } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_Fishbone_Defaults } from '@app/advisor-ui-shared';
export const ConfigKeyFE_Fishbone_Defaults = new AppConfigKey_FE(ConfigKey_Fishbone_Defaults);
//# sourceMappingURL=app-configs.js.map